module.exports = __webpack_public_path__ + "img/Newspaper.2439806e.jpg";